import { render, staticRenderFns } from "./AdsetEditingBrief.vue?vue&type=template&id=79c7b9ae&"
import script from "./AdsetEditingBrief.vue?vue&type=script&lang=ts&"
export * from "./AdsetEditingBrief.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports